import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=41f1eb74&scoped=true&"
import script from "./AccordionItem.vue?vue&type=script&lang=ts&"
export * from "./AccordionItem.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=41f1eb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f1eb74",
  null
  
)

export default component.exports